import { RequestProvider } from '@/shared/providers/request.provider';
import { TEMPLATES_API, TEMPLATES_SCOPE } from '../values/templates.values';

class TemplatesServiceClass {

  searchTemplates(page: number = 0, pageSize: number = 50, type: string = '', scope: TEMPLATES_SCOPE = TEMPLATES_SCOPE.PUBLIC): Promise<any> {
    return new Promise((resolve, reject) => {
      let req = `${TEMPLATES_API.SEARCH_TEMPLATES}/?page=${page}&pageSize=${pageSize}&scope=${scope}&type=${type}`;
      RequestProvider.get(req).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

}

export const TemplatesService = new TemplatesServiceClass();